/**
 * Localized Content Injection
 *
 * Refer to wlWriteUserLocationCookie() in lib/helpers.php for cookie creation.
 */

// Vendors
import $ from 'jquery';

// Utilities
import { getCookieValue, getQueryParamsAsObject } from '../lib/utilities';

if ($('[data-inject-localized-content]').length) {
  const { preview } = getQueryParamsAsObject();
  let userLocation = getCookieValue('perc_lc_loc')
    ? getCookieValue('perc_lc_loc')
    : window.wlUConf;
  let components = [];

  // Make sure there's actual data before parsing
  if (userLocation !== undefined) {
    userLocation = JSON.parse(userLocation);
  }

  // Get all components that need data injected
  $('[data-inject-localized-content]').each((index, element) =>
    components.push(element.dataset.injectLocalizedContent)
  );

  // Get content if cookie data exists.
  if (userLocation) {
    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'wl_get_localized_content',
        post_id: $('body').data('pid'),
        state: atob(userLocation.s),
        city: atob(userLocation.c),
        preview
      },
      success: ({ success, data }) => {
        if (success) injectContent(data);
        else clearAllLoadingStates();
      }
    });
  } else {
    // Error retrieving cookie, abort.
    clearAllLoadingStates();
  }

  function injectContent(localizedData) {
    localizedData.map(({ name, data }, index) => {
      for (const element in data) {
        // Use more tailored function for Marquee component
        if (name === 'marquee')
          return injectMarqueeContent(localizedData[index]);

        if (data[element].hasOwnProperty('attributes')) {
          $(element).attr(data[element].attributes);
        }

        if (data[element].hasOwnProperty('children')) {
          for (const child in data[element].children) {
            const childObj = data[element].children[child];

            if (childObj.hasOwnProperty('attributes')) {
              $(`${element} ${child}`).attr(childObj.attributes);
            }

            if (childObj.hasOwnProperty('content')) {
              $(`${element} ${child}`).html(childObj.content);
            }
          }
        }

        $(element).removeClass(`${element}--is-loading`.replace('.', ''));
      }
    });

    // In case we missed a few there.
    clearAllLoadingStates();
  }

  function injectMarqueeContent(localizedData) {
    const { style, watermark } = localizedData;
    const { slides } = localizedData.data;
    const $marquee = $('.marquee');
    const $marquee__container = $marquee.find('.marquee__container');
    let marquee__carouselHTML = '<div class="marquee__carousel">';
    let marquee__navHTML = '<div class="marquee__nav">';

    // Construct slide elements
    slides.map((slide, index) => {
      marquee__carouselHTML += `
      <div data-marquee-slide="${index}" class="marquee__slide ${
        index === 0 ? 'marquee__slide--initial' : ''
      }">
        <div class="marquee__content">
        ${
          style === 'detail'
            ? `
          <h1 class="marquee__title heading-highlighted">
            <span class="heading-highlighted__text">${slide.title}</span>
            <span class="heading-highlighted__highlight">${slide.title}</span>
          </h1>`
            : ''
        }
          <div class="marquee__media" style="background-image: url(${
            slide.image.sizes['marquee-default']
          });">
            <img src="/wp-content/themes/wlion/images/placeholders/795x698.gif">
          </div>
          <div class="marquee__text">
            <div class="marquee__text-background"></div>
            <h1 class="marquee__title heading-highlighted">
              <span class="heading-highlighted__text">${slide.title}</span>
              <span class="heading-highlighted__highlight">${slide.title}</span>
            </h1>
            <div class="marquee__text-body">
              ${
                slide.subhead
                  ? `<div class="marquee__subhead">${slide.subhead}</div>`
                  : ''
              }
              ${
                slide.description
                  ? `<div class="marquee__description">${slide.description}</div>`
                  : ''
              }
              <div class="marquee__action"></div>
            </div>
          </div>
        </div>
      </div>`;

      // Create Nav thumbnails, if applicable
      if (slides.length > 1) {
        marquee__navHTML += `<div data-marquee-thumb="${index}" class="marquee__thumb ${
          index === 0 ? 'marquee__thumb--active' : ''
        }">
          <span class="marquee__thumb-image" style="background-image: url(${
            slide.image.sizes['marquee-thumb']
          });"></span>
        </div>`;
      }
    });

    marquee__carouselHTML += '</div>';
    marquee__navHTML += '</div>';

    // Empty out element.
    $marquee__container.html('');

    // Add slides.
    $marquee__container.append(marquee__carouselHTML);

    // Add nav, if applicable.
    if (slides.length > 1) $marquee__container.append(marquee__navHTML);

    if ($('.marquee__slide--initial').length) {
      $('.marquee__slide--initial').addClass('marquee__slide--active');
      $marquee.removeClass('marquee--is-loading');
    } else {
      $(`[data-marquee-slide="0"]`).addClass('marquee__slide--active');
    }
  }

  function clearAllLoadingStates() {
    $('[data-inject-localized-content]').each((index, element) => {
      $(element)
        .removeClass(`${element.dataset.injectLocalizedContent}--is-loading`)
        .removeAttr('data-inject-localized-content');
    });
  }
}
